import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { useUnsavedChangesConfirmationModal } from './useUnsavedChangesConfirmationModal';
import { ConfirmationModal } from '../ConfirmationModal';

export const UnsavedChangesConfirmationModal = () => {
  const { onDiscard, onDismiss, isConfirmationModalVisible } = useUnsavedChangesConfirmationModal();
  const { t } = useTranslation();

  if (!isConfirmationModalVisible) {
    return null;
  }

  return (
    <ConfirmationModal
      type="horizontal"
      open={isConfirmationModalVisible}
      title={t('item.unsavedChanges')}
      cancel={{ action: onDismiss }}
      confirm={{ action: onDiscard, title: t('app.discard') }}
      destructive
    >
      <Typography>{t('item.unsavedChanges.text1')}</Typography>
      <Typography>{t('item.unsavedChanges.text2')}</Typography>
    </ConfirmationModal>
  );
};
